import { Token } from 'styled-system/tokens';
import { LoadingButtonType } from '@/common/components/base/button/Button.type.ts';
import Button from '@/common/components/base/button/Button.tsx';
import CircularLoading from '@/common/components/base/Loading/CircularLoading.tsx';
import { ButtonVariants } from '@/common/components/base/button/button.recipe.ts';

const LoadingButton = ({
  loadingColor,
  loading,
  children,
  fullWidth = false,
  ...props
}: LoadingButtonType) => {
  const LoadingColors: Record<ButtonVariants['color'], Token> = {
    common: 'colors.black-1',
    danger: 'colors.red-1',
    primary: 'colors.purple-primary',
    success: 'colors.green-2',
  };

  return (
    <Button
      fullWidth={true}
      {...props}
      gap="5px"
      disabled={loading || props.disabled}
    >
      {children}
      {loading ? (
        <CircularLoading
          width="30"
          color={LoadingColors[loadingColor ?? 'primary'] as Token}
        />
      ) : null}
    </Button>
  );
};
export default LoadingButton;
